import React from "react";
import { Box, styled, Typography } from "@material-ui/core";

import { TicketPriority } from "../../../api/services";
import {
  CircleArrowTop,
  CircleArrowBottom,
  CircleArrowRight,
} from "../../../icons";

const HighIcon = styled(CircleArrowTop)(({ theme }) => ({
  width: 22,
  height: 22,
  fill: theme.palette.warning.main,
}));

const CriticalIcon = styled(CircleArrowTop)(({ theme }) => ({
  width: 22,
  height: 22,
  fill: theme.palette.error.main,
}));

const MedIcon = styled(CircleArrowRight)(({ theme }) => ({
  width: 22,
  height: 22,
  fill: theme.palette.secondary.main,
}));

const LowIcon = styled(CircleArrowBottom)(({ theme }) => ({
  width: 22,
  height: 22,
  fill: theme.palette.text.secondary,
}));

export const TicketPriorityCell: React.FC<{
  priority: TicketPriority;
}> = ({ priority }) => (
  <Box display="flex" alignItems="center">
    {priority === "Critical" ? (
      <CriticalIcon />
    ) : priority === "High" ? (
      <HighIcon />
    ) : priority === "Major" ? (
      <HighIcon />
    ) : priority === "Medium" ? (
      <MedIcon />
    ) : (
      <LowIcon />
    )}
    <Box ml={0.5}>
      <Typography variant="body1" component="span">
        {priority}
      </Typography>
    </Box>
  </Box>
);
